module.exports = "<div   class=\"logotype\" [class.black]=\"appContextService.IsWhite()\">\n<img class=\"logoimg\"/>\n<!--<h1>Renoaaaaaa</h1>-->\n\n</div>\n"